<template>
  <div>
    <v-container
      class="bk-image ma-0 pa-0 primary--font"
      fluid
    >
    <transition name="fade" mode="out-in" appear>
      <v-row
        align="center"
        justify="center"
        class="login-wrap ma-0"
        :style="{backgroundColor:'#03b6fc',backgroundImage: 'url(' + require('@/assets/login_image.png') + ')'}"
      >
        <v-col

          cols="10"
          class="light"
        >
          <v-card

            align="center"
            justify="center"
            :max-width="options.maxWidth"
            class="mx-auto px-10 auth-card"
            :class="$vuetify.breakpoint.smAndDown ? (device !== 'iphone5se' ? 'pt-5' : '') : 'pt-10'"
          >
            <v-row>
              <v-col>
                <v-img
                  justify="center"
                  class="m-auto"
                  contain
                  src="/img/icons/maropost-logo.svg"
                />
              </v-col>
            </v-row>
            <router-view :options="options" />
          </v-card>
        </v-col>
      </v-row>
    </transition>

    <div :class="$vuetify.breakpoint.smAndDown ? `mobile-footer-text footer-text ${device}` : 'footer-text'">
      &copy; Maropost Inc {{ ($dateEST()).getFullYear() }}<span class="mx-3">|</span><a
            target="_blank"
            style="text-decoration:none;color:white;"
            href="https://www.maropost.com/privacy-policy/"
          >Privacy Policy</a>
    </div>

    </v-container>
    
  </div>
</template>

<script>
// TODO replace url's with environment variables
  export default {
    computed: {
      device () {
        if(this.$vuetify.breakpoint.width === 280 && this.$vuetify.breakpoint.height === 653){ // GalaxyFold...
          return 'galaxy-fold';
        }

        if(this.$vuetify.breakpoint.width === 768 && this.$vuetify.breakpoint.height === 1024){ // ipad...
          return 'ipad';
        }
        
        if(this.$vuetify.breakpoint.width === 320 && this.$vuetify.breakpoint.height === 568){ // iphone5se...
          return 'iphone5se';
        }

        return ''
      },
    },
    data() {
      return {
        options: {
          'maxWidth' : 390
        }
      }
    }
  }
</script>

<style>
.bk-image {
  position: relative;
  text-align: center;
  color: white;
}
.mobile-footer-text{
  position: fixed !important;
  bottom:-24px !important;
}
.galaxy-fold{
  width: 80%;
}
.ipad{
  bottom: 0 !important;
}
.iphone5se{
  left: 50% !important;
  bottom:-8px !important;
  font-size:13px !important;
  width:80%;
}
.footer-text {
  position: absolute;
  bottom: 8px;
  left: 50%;
  transform: translate(-50%, -50%);
  color: white;
}
iframe.post{
  visibility: hidden;
  opacity: 0;
  position:absolute;
  top:0;
  left:-100%;
  z-index:-1;
}
.login-wrap {
  background-color: #00aae9;
  background-size: cover;
  width: 100vw;
  height: 100vh;
}
.auth-card .custom-btn{
  text-transform: none;
  font-family: "Roboto", sans-serif !important;
}
.auth-card .custom-login {
  background-color: #4c5463 !important;
  color: #ffffff !important;
}
.login-grey--text, .auth-card .login-grey--text{
  color: rgba(0,0,0,0.6) !important;
}
.auth-card {
  overflow: hidden;
}
</style>
